// module Solr WLF - 3x1010

// ************************************************************************************************
// TIPI
// ************************************************************************************************

export class FieldType {}

FieldType.UnknownField = "unknown";
FieldType.ComplexField = "complex";
FieldType.StrField = "string";
FieldType.TextField = "text";
FieldType.LongPointField = "numint";
FieldType.DateRangeField = "date";
FieldType.DoublePointField = "numfloat";
FieldType.BoolField = "bool";
// caso peciale
FieldType.ROOT = "complex"; // complex

// ************************************************************************************************
// FLAGS
// ************************************************************************************************

export class FieldFlags {}
FieldFlags.FLAG_EXISTS = 0x1;
FieldFlags.FLAG_VIEW = 0x2;
FieldFlags.FLAG_QUERY = 0x4;

// ************************************************************************************************
// OPERATORI
// ************************************************************************************************

export class QueryNodeCompareType {
  static getNumArgs(compareType) {
    let ret = 1;
    if (compareType == QueryNodeCompareType.cNOTNULL) return 0;
    if (compareType == QueryNodeCompareType.cISNULL) return 0;
    if (compareType == QueryNodeCompareType.cEXISTS) return 0;
    return 1;
  }
}
// common
QueryNodeCompareType.cNOTNULL = "cNOTNULL";
QueryNodeCompareType.cISNULL = "cISNULL";
QueryNodeCompareType.cEXISTS = "cEXISTS";
// text
QueryNodeCompareType.tPHRASE = "tPHRASE"; /* human no */
QueryNodeCompareType.tPHRASEw = "tPHRASEw"; // la donzelletta vien dalla campagna --> don* vie* dal* cam*
QueryNodeCompareType.tALLTERMS = "tALLTERMS"; /* human no */
QueryNodeCompareType.tALLTERMSw = "tALLTERMSw"; // la donzelletta vien dalla campagna --> *camp* *don*
QueryNodeCompareType.tANYTERM = "tANYTERM"; /* human no */
QueryNodeCompareType.tANYTERMw = "tANYTERMw"; // la donzelletta vien dalla campagna --> *don* *pippo*
// string
QueryNodeCompareType.sEQUALS = "sEQUALS"; // uguale /* human no */
QueryNodeCompareType.sEQUALSw = "sEQUALSw"; // uguale
QueryNodeCompareType.sSTARTS = "sSTARTS"; // xxx* /* human no */
QueryNodeCompareType.sENDS = "sENDS"; // *xxx /* human no */
QueryNodeCompareType.sCONTAINS = "sCONTAINS"; // *xxx* /* human no */
// numeric
QueryNodeCompareType.nEQUALS = "nEQUALS"; // uguale
// date
QueryNodeCompareType.dEQUALS = "dEQUALS"; // uguale
// boolean
QueryNodeCompareType.bEQUALS = "bEQUALS"; // uguale

// ************************************************************************************************
// Occurency
// ************************************************************************************************

export class QueryNodeOccurencyType {}
QueryNodeOccurencyType.MUST = "MUST";
QueryNodeOccurencyType.NOT = "NOT";

// ************************************************************************************************
// QueryNodeBooleanType
// ************************************************************************************************

export class QueryNodeBooleanType {}
QueryNodeBooleanType.AND = "AND";
QueryNodeBooleanType.OR = "OR";
//
QueryNodeBooleanType.EXISTS = "EXISTS";

// ************************************************************************************************
// SCHEMA
// ************************************************************************************************

export class Schema {
  constructor(collectionName) {
    this.collectionName = collectionName;
    this.schema = SolrCOLLECTIONS[this.collectionName];
  }

  get CollectionName() {
    return this.schema.CollectionName;
  }

  get Fields() {
    return this.schema.Fields;
  }

  getCollectionNames(filtered = false) {
    // Fa un po' juvare così ma non ho modo di capire dallo schema quali sono le collection da escludere
    const roles = TheApp.CurrentContext.userSession.userData.usr.Roles;
    if (roles.indexOf("SUPERADMIN") > -1) {
      // Super admin
      let exclude;
      if (!Schema.INCLUDE_FILMOGRAFIA) {
        exclude = ["FILMOGRAFIA_coll", "ENTITA_coll", "DocumentTreeV"];
      } else {
        exclude = ["ENTITA_coll", "DocumentTreeV"];
      }
      const ret = [];
      for (let name in SolrCOLLECTIONS) {
        let take = true;
        if (filtered) {
          take = exclude.indexOf(name) == -1;
        }
        if (take) ret.push(name);
      }
      return ret;
    } else {
      // Utente normale
      const a = roles.split(",");
      a.shift();
      if (Schema.INCLUDE_FILMOGRAFIA) {
        if (a.indexOf("FILMOGRAFIA_coll") === -1) {
          a.push("FILMOGRAFIA_coll");
        }
      }

      return a;
    }
  }

  static getDefaultCollectionName() {
    const roles = TheApp.CurrentContext.userSession.userData.usr.Roles;
    let collectionName;
    if (roles.indexOf("SUPERADMIN") > -1) {
      collectionName = "FILMOGRAFIA_coll";
    } else {
      const a = roles.split(",");
      a.shift();
      collectionName = a.shift();
    }
    return collectionName;
  }

  getFieldByName(name) {
    return this.schema.Fields.find((f) => f.Name == name);
  }

  // operatori per un certo tipo di campo
  static getOperatorsForType(fieldType, forLookup) {
    let ret = [];
    switch (fieldType) {
      case FieldType.TextField:
        if (forLookup) {
          return [QueryNodeCompareType.sEQUALS, QueryNodeCompareType.cNOTNULL, QueryNodeCompareType.cISNULL];
        }
        return [QueryNodeCompareType.tPHRASEw, QueryNodeCompareType.tPHRASE, QueryNodeCompareType.tALLTERMS, QueryNodeCompareType.tALLTERMSw, QueryNodeCompareType.tANYTERM, QueryNodeCompareType.tANYTERMw, QueryNodeCompareType.cNOTNULL, QueryNodeCompareType.cISNULL];
      case FieldType.StrField:
        if (forLookup) {
          return [QueryNodeCompareType.sEQUALS, QueryNodeCompareType.cNOTNULL, QueryNodeCompareType.cISNULL];
        }
        return [QueryNodeCompareType.sEQUALSw, QueryNodeCompareType.sEQUALS, QueryNodeCompareType.sSTARTS, QueryNodeCompareType.sENDS, QueryNodeCompareType.sCONTAINS, QueryNodeCompareType.cNOTNULL, QueryNodeCompareType.cISNULL];
      case FieldType.LongPointField:
      case FieldType.DoublePointField:
        return [QueryNodeCompareType.nEQUALS, QueryNodeCompareType.cNOTNULL, QueryNodeCompareType.cISNULL];
      case FieldType.DateRangeField:
        return [QueryNodeCompareType.dEQUALS, QueryNodeCompareType.cNOTNULL, QueryNodeCompareType.cISNULL];
      case FieldType.BoolField:
        return [QueryNodeCompareType.bEQUALS, QueryNodeCompareType.cNOTNULL, QueryNodeCompareType.cISNULL];
    }
    return [QueryNodeCompareType.sEQUALS, QueryNodeCompareType.cNOTNULL, QueryNodeCompareType.cISNULL];
  }

  // operatori per un certo tipo di campo
  static getOperatorsForHumanType(fieldType, forLookup) {
    let ret = [];
    switch (fieldType) {
      case FieldType.TextField:
        if (forLookup) {
          return [QueryNodeCompareType.sEQUALS, QueryNodeCompareType.cISNULL, QueryNodeCompareType.cNOTNULL];
        }
        return [QueryNodeCompareType.tPHRASEw, QueryNodeCompareType.tPHRASE, QueryNodeCompareType.tALLTERMS, QueryNodeCompareType.tALLTERMSw, QueryNodeCompareType.tANYTERM, QueryNodeCompareType.tANYTERMw, QueryNodeCompareType.cISNULL, QueryNodeCompareType.cNOTNULL];
      case FieldType.StrField:
        if (forLookup) {
          return [QueryNodeCompareType.sEQUALS, QueryNodeCompareType.cISNULL, QueryNodeCompareType.cNOTNULL];
        }
        return [QueryNodeCompareType.sEQUALSw, QueryNodeCompareType.sEQUALS, QueryNodeCompareType.sSTARTS, QueryNodeCompareType.sENDS, QueryNodeCompareType.sCONTAINS, QueryNodeCompareType.cISNULL, QueryNodeCompareType.cNOTNULL];
      case FieldType.LongPointField:
      case FieldType.DoublePointField:
        return [QueryNodeCompareType.nEQUALS, QueryNodeCompareType.cISNULL, QueryNodeCompareType.cNOTNULL];
      case FieldType.DateRangeField:
        return [QueryNodeCompareType.dEQUALS, QueryNodeCompareType.cISNULL, QueryNodeCompareType.cNOTNULL];
      case FieldType.BoolField:
        return [QueryNodeCompareType.bEQUALS, QueryNodeCompareType.cISNULL, QueryNodeCompareType.cNOTNULL];
    }
    return [QueryNodeCompareType.sEQUALS, QueryNodeCompareType.cISNULL, QueryNodeCompareType.cNOTNULL];
  }

  // trova un campo per path : -->  QueryField
  findFieldByPath(path) {
    // creo un oggetto root fittizio
    let current = new QueryField(null);
    current.Flags = 0xff;
    current.Type = FieldType.ROOT;
    current.Fields = this.schema.Fields;
    //
    let _relations = [this.CollectionName];
    //
    let tokens = path.split("/").filter((i) => i != "");
    for (let t of tokens) {
      let fld = current.Fields ? current.Fields.find((f) => f.Name == t) : null;
      if (fld == null) fld = current.Fields ? current.Fields.find((f) => f.Relation && f.Relation.Name == t) : null;
      if (!fld) return null;
      //
      let f1 = new QueryField(fld, true); // Object.assign({}, fld);
      f1._path = QueryField.mergePath(current._path, f1.Name);
      f1._label = QueryField.mergePath(current._label, f1.Label);
      //
      if (f1.Relation) _relations.push(f1.Relation);
      //
      current = f1;
    }
    current._relations = _relations;
    //
    return current;
  }

  // solo i campi di un certo contesto di questo schema -> list of QueryField
  getContextFields(path, flags, includeRelation = true, includeComplex = true, avoidLoop = true, subFields = false) {
    let ret = [];
    let fld1 = this.findFieldByPath(path);
    if (fld1 == null || !fld1.Fields) return null;
    //
    for (let f of fld1.Fields) {
      if ((f.Flags & FieldFlags.FLAG_EXISTS) == 0) continue;
      if ((f.Flags & flags) != flags) continue;
      // avoid loop
      let _includeRelation = includeRelation;
      if (_includeRelation && avoidLoop && fld1._relations.indexOf(f.Relation ? f.Relation.JoinCollectionName : "$$$") > -1) _includeRelation = false;
      let f1 = new QueryField(f, _includeRelation);
      if (f1.Fields && !includeComplex) continue;
      //
      f1._path = QueryField.mergePath(fld1._path, f1.Name);
      f1._label = QueryField.mergePath(fld1._label, f1.Label);
      //
      if (!f1.Relation || f1.RelationType != "DB") ret.push(f1);
      // se sono in strict mode non vado oltre
      if (Schema.StrictMode) subFields = false;
      // subfields
      if (subFields && f1.Fields) {
        let _ret = this.getContextFields(f1._path, flags, includeRelation, includeComplex, avoidLoop, subFields);
        for (let _f of _ret) {
          _f.Label = f1.Label + " / " + _f.Label;
          ret.push(_f);
        }
      }
    }
    //
    return ret;
  }

  // ************************************************************************************************
  // TUTTI I CAMPI
  // ************************************************************************************************

  // list of QueryField
  getAllFields(flags, useRelation = 1, includeComplex = false) {
    let opt = { flags: flags, includeComplex: includeComplex, useRelation: useRelation };
    var ret = this._getAllFields(this.schema.Fields, opt, "", "", 0);
    return ret;
  }

  _getAllFields(fields, opt, _path, _label, relationLevel) {
    let ret = [];

    for (let f of fields) {
      // se non esiste blocco
      if ((f.Flags & FieldFlags.FLAG_EXISTS) == 0) continue;

      // relazione
      if (opt.useRelation > 0 && f.Relation && relationLevel < opt.useRelation) {
        let f1 = new QueryField(f, true); // Object.assign({}, f);
        f1._path = QueryField.mergePath(_path, f1.Name);
        f1._label = QueryField.mergePath(_label, f1.Label);
        // complesso (root) // NON METO DB
        if (opt.includeComplex && f1.RelationType != "DB") {
          if ((f.Flags & opt.flags) == opt.flags) {
            ret.push(f1);
          }
        }
        // sottonodi
        ret.push(...this._getAllFields(f1.Fields, opt, f1._path, f1._label, relationLevel + 1));
        //
        continue;
      }
      // se semplice
      if (!f.Fields) {
        if ((f.Flags & opt.flags) == opt.flags) {
          let f1 = new QueryField(f); // Object.assign({}, f);
          f1._path = QueryField.mergePath(_path, f1.Name);
          f1._label = QueryField.mergePath(_label, f1.Label);
          ret.push(f1);
        }
        continue;
      }
      // complesso
      if (opt.includeComplex) {
        if ((f.Flags & opt.flags) == opt.flags) {
          let f1 = new QueryField(f); // Object.assign({}, f);
          f1._path = QueryField.mergePath(_path, f1.Name);
          f1._label = QueryField.mergePath(_label, f1.Label);
          ret.push(f1);
        }
      }
      // sottonodi
      ret.push(...this._getAllFields(f.Fields, opt, _path + "/" + f.Name, _label + "/" + f.Label, relationLevel));
    }
    return ret;
  }
}
// strict mode
Schema.StrictMode = false;
// ************************************************************************************************
// QueyBuilder
// ************************************************************************************************

export class QueryField {
  constructor($schemaField, useRelation = false) {
    this._path = "/";
    this._label = "/";
    this.Name = "";
    this.Label = "";
    this.Relation = null;
    this.RelationType = "SOLR";
    this.Flags = 0;
    this.IsArray = false;
    this.Type = FieldType.UnknownField;
    this.Lookup = null;
    // non seralizzare
    this.Fields = null;
    this.Field = $schemaField;
    //
    if ($schemaField) {
      this.Name = $schemaField.Name;
      this.Label = $schemaField.Label.replace(/\//g, "-");
      this.Relation = null;
      this.RelationType = "SOLR";
      this.Type = $schemaField.Type;
      this.Flags = $schemaField.Flags;
      this.IsArray = $schemaField.IsArray;
      this.Fields = $schemaField.Fields;
      this.Lookup = $schemaField.Lookup;
      // se relazione
      if (useRelation && $schemaField.Relation) {
        let _schema = new Schema($schemaField.Relation.JoinCollectionName);
        //
        this.Relation = $schemaField.Relation.JoinCollectionName;
        this.RelationType = $schemaField.Relation.Type;
        this.Name = $schemaField.Relation.Name;
        this.Label = $schemaField.Relation.Label.replace(/\//g, "-");
        this.Type = FieldType.ComplexField;
        this.IsArray = true;
        this.Fields = _schema.Fields;
      }
    }
  }

  static mergePath(p0, p1) {
    let _p0 = p0.endsWith("/") ? p0.substring(0, p0.length - 1) : p0;
    let _p1 = p1.startsWith("/") ? p1.substring(1) : p1;
    return _p0 + "/" + _p1;
  }
}

export class QueryNode {
  constructor($field /* of QueryField */) {
    this.id = "QN" + QueryNode.LastUid++;
    this.Field = $field;
    this.Occurency = QueryNodeOccurencyType.MUST;
  }
  //
  removeById(id, recursive) {}

  get type() {
    return "QueryNode";
  }
}
QueryNode.LastUid = new Date().getTime();

export class QueryNodeBoolean extends QueryNode {
  constructor($field /* of QueryField */, isExists = false) {
    super($field);
    this.AdmitExists = isExists;
    if (this.AdmitExists) {
      this.Operators = [QueryNodeBooleanType.EXISTS, QueryNodeBooleanType.AND, QueryNodeBooleanType.OR];
    } else {
      this.Operators = [QueryNodeBooleanType.AND, QueryNodeBooleanType.OR];
    }
    this._operatorIndex = 0;
    this.Clauses = [];
    // deve essere complesso
    if (this.Field.Type != FieldType.ComplexField && this.Field.Type != FieldType.ROOT) throw atob("SGFpIHNjcml0dG8gY2F6emF0ZSE=") + " Invalid field type";
  }

  get Operator() {
    return this.Operators[this._operatorIndex];
  }

  set Operator(value) {
    let idx = this.Operators.indexOf(value);
    this._operatorIndex = idx > -1 ? idx : 0;
  }

  toggleOperator() {
    this._operatorIndex = (this._operatorIndex + 1) % this.Operators.length;
  }

  // aggiunge un nodo
  addSubNode(node) {
    // controllo che sia compatibile
    let parent = this.Field._path.split("/").filter((i) => i != "");
    let child = node.Field._path.split("/").filter((i) => i != "");
    // STRICT MODE
    if (Schema.StrictMode) {
      if (child.length < parent.length || child.length > parent.length + 1) throw atob("SGFpIHNjcml0dG8gY2F6emF0ZSE=") + " Invalid path";
    } else {
      if (child.length < parent.length) throw atob("SGFpIHNjcml0dG8gY2F6emF0ZSE=") + " Invalid path";
    }
    for (let i = 0; i < parent.length; i++) {
      if (parent[i] != child[i]) throw atob("SGFpIHNjcml0dG8gY2F6emF0ZSE=") + " Invalid path";
    }
    //
    this.Clauses.push(node);
  }

  // rimuove un nodo per id
  removeSubNodeById(id, recursive) {
    let idx = this.Clauses.findIndex((c) => c.id == id);
    if (idx > -1) {
      this.Clauses.splice(idx, 1);
      return true;
    }
    if (recursive) {
      for (let c of this.Clauses) {
        if (c instanceof QueryNodeBoolean) {
          if (c.removeSubNodeById(id, recursive)) return true;
        }
      }
    }
    return false;
  }
  get type() {
    return "QueryNodeBoolean";
  }
}

export class QueryNodeTerm extends QueryNode {
  constructor($field) {
    super($field);
    //
    this.Operators = Schema.getOperatorsForHumanType(this.Field.Type, this.Field.Lookup ? true : false);
    this.Value = "";
    this.Compare = this.Operators[0];
    // NON deve essere complesso
    if (this.Field.Type == FieldType.ComplexField || this.Field.Type == FieldType.ROOT) throw atob("SGFpIHNjcml0dG8gY2F6emF0ZSE=") + " Invalid field type";
  }
  get type() {
    return "QueryNodeTerm";
  }
}

export class QueryWrapper {
  static toJsonObject(node, collectionName = null) {
    let ret = {
      id: node.id,
      Field: {},
      Occurency: node.Occurency,
      type: node.type,
    };
    ret.Field = {
      _path: node.Field._path,
      _label: node.Field._label,
      Name: node.Field.Name,
      Label: node.Field.Label,
      Relation: node.Field.Relation,
      Flags: node.Field.Flags,
      IsArray: node.Field.IsArray,
      Type: node.Field.Type,
      Lookup: node.Field.Lookup,
    };
    if (node instanceof QueryNodeTerm) {
      ret.Value = node.Value;
      ret.Compare = node.Compare;
      // this.Operators
    }
    if (node instanceof QueryNodeBoolean) {
      ret.AdmitExists = node.AdmitExists;
      ret.Operator = node.Operator;
      ret.Clauses = [];
      // this.Operators
      for (let c of node.Clauses) {
        ret.Clauses.push(QueryWrapper.toJsonObject(c));
      }
    }
    // metto collection name
    if (collectionName) {
      ret.CollectionName = collectionName;
    }
    //
    return ret;
  }

  static fromJsonObject(json, schema = null) {
    if (schema == null) schema = new Schema(json.CollectionName);
    if (schema == null) throw atob("SGFpIHNjcml0dG8gY2F6emF0ZSE=") + " Invalid collection";
    //
    var n = json;
    //
    if (n.type == "QueryNodeBoolean") {
      let q = new QueryNodeBoolean(schema.findFieldByPath(n.Field._path), n.AdmitExists);
      q.Occurency = n.Occurency;
      q.Operator = n.Operator;
      //
      for (let c of n.Clauses) {
        let t = QueryWrapper.fromJsonObject(c, schema);
        if (t == null) throw atob("SGFpIHNjcml0dG8gY2F6emF0ZSE=") + " Invalid field";
        q.addSubNode(t);
      }
      //
      return q;
    }
    if (n.type == "QueryNodeTerm") {
      let q = new QueryNodeTerm(schema.findFieldByPath(n.Field._path));
      q.Occurency = n.Occurency;
      q.Compare = n.Compare;
      q.Value = n.Value;
      //
      return q;
    }
    throw atob("SGFpIHNjcml0dG8gY2F6emF0ZSE=") + " Invalid field";
  }
}

Schema.INCLUDE_FILMOGRAFIA = true;
